// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"2c07a72f","246":"73f3898f","440":"73cebb1c","467":"f2643c66","523":"754a7fa1","547":"73cebb1c","999":"a625fd16"}[chunkId] + ".css";
};